"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styles = require("../styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var styles = function styles(theme) {
  if (!("scrollbars" in theme)) {
    theme.scrollbars = {
      main: {}
    };
  }

  return {
    root: {
      top: 0,
      height: "100%",
      width: _styles.mainPanelWidth,
      position: "absolute",
      border: "none"
    },
    rootWrapper: {
      zIndex: theme.zIndex.appBar - 1,
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      pointerEvents: "none"
    },
    rootWrapperOpen: {
      pointerEvents: "auto"
    },
    menu: {
      display: "flex",
      flexDirection: "column",
      height: "100%",
      borderRight: "1px solid " + theme.palette.divider
    },
    modal: {
      zIndex: theme.zIndex.appBar - 1
    },
    title: {
      background: theme.palette.grey[100],
      borderBottom: "1px solid ".concat(theme.palette.grey[200]),
      color: theme.palette.text.secondary,
      display: "block",
      fontSize: ".75rem",
      fontWeight: "900",
      padding: "1rem 2rem",
      textTransform: "uppercase",
      userSelect: "none"
    },
    wrapper: _objectSpread({
      padding: ".5rem 0",
      flexGrow: 1
    }, theme.scrollbars.main),
    button: {
      background: "#525252",
      bottom: "0",
      color: theme.palette.primary.contrastText,
      justifyContent: "left",
      letterSpacing: "0",
      padding: ".75rem 2rem",
      position: "sticky",
      textTransform: "none",
      "&:hover": {
        background: "#626262"
      }
    }
  };
};

exports.styles = styles;